module.exports = __webpack_public_path__ + "static/media/SimplonMono.fa2c6583.woff2";